<template>
    <div>
        <h3>{{ $t("compesation.title") }}</h3>
        <div class="flex_row">
                <SwitchButtons name="notifications" :values="types" :onChange="getNotifications" />
                <button :disabled='validChange' @click="save()" type=" button" class="btn control upload-btn save-btn">{{ $t("compesation.save") }}</button>
            </div>
        <div class="form-container">
            
        <div class="section-container recipients">
            
            <div v-if="alertType == 'economicas'">
                <div class="input-container mt">
                    <label for="alertType"> {{ $t("compesation.marriage") }}</label>
                    <input v-model="matrimonio" type="text" id="title" name="title" placeholder="Matrimonio"
                         />
                </div>
                <div class="input-container mt">
                    <label for="alertType">{{ $t("compesation.spouse") }}</label>
                    <input v-model="concubina" type="text" id="title" name="title" placeholder="Definición cónyuge o concubina/o"
                         />
                </div>
                <div class="input-container mt">
                    <label for="alertType"> {{ $t("compesation.father") }}</label>
                    <input v-model="padre" type="text" id="title" name="title" placeholder="Defunción de padre o madre"
                         />
                </div>
                <div class="input-container mt">
                    <label for="alertType"> {{ $t("compesation.son") }}  </label>
                    <input v-model="hijo" type="text" id="title" name="title" placeholder="Defunción de hijo o hija"
                         />
                </div>
                <div class="input-container mt">
                    <label for="alertType"> {{ $t("compesation.paternity") }}  </label>
                    <input v-model="paternidad" type="text" id="title" name="title" placeholder="Paternidad"
                         />
                </div>
            </div>
            <div v-if="alertType == 'subsidiadas'">
                <div class="input-container mt">
                    <label for="alertType"> {{ $t("compesation.subsidized") }} 1</label>
                    <input v-model="subsidiada_1" type="text" id="title" name="title" placeholder="Prestación subsidiada 1"
                         />
                </div>
                <div class="input-container mt">
                    <label for="alertType">{{ $t("compesation.subsidized") }} 2</label>
                    <input v-model="subsidiada_2" type="text" id="title" name="title" placeholder="Prestación subsidiada 2"
                         />
                </div>
                <div class="input-container mt">
                    <label for="alertType">{{ $t("compesation.subsidized") }} 3</label>
                    <input v-model="subsidiada_3" type="text" id="title" name="title" placeholder="Prestación subsidiada 3"
                         />
                </div>
                <div class="input-container mt">
                    <label for="alertType">{{ $t("compesation.subsidized") }} 4</label>
                    <input v-model="subsidiada_4" type="text" id="title" name="title" placeholder="Prestación subsidiada 4"
                         />
                </div>
                
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import API_SERVICE from "@/lib/api/Compesation";
const api = new API_SERVICE();
const InfoCard = () => import("@/components/InfoCard");
const SwitchButtons = () => import("@/components/Switch");
// Importamos JQuery
const $ = require("jquery");
// Lo declaramos globalmente
window.$ = $;
export default {
    name: "NewsList",
    components: {
        InfoCard,
        SwitchButtons,
    },
    data: function () {
        return { 
            validChange:true,
            dataTemporalEconomica:{},
            dataTemporalSubsidial:{},
            matrimonio:"",
            concubina:"",
            padre:"",
            hijo:"",
            paternidad:"",
            subsidiada_1:"",
            subsidiada_2:"",
            subsidiada_3:"",
            subsidiada_4:"",
            news: [{}],
            isLoading: false,
            modalActive: false,
            notifId: null,
            alertType: "economicas",
        };
    },
    computed: {
        types: function () {

            return [
                {
                    label: this.$t("compesation.noEconomic"),
                    value: "economicas",
                },
                {
                    label: this.$t("compesation.sub"),
                    value: "subsidiadas",
                },

                // {
                //   label: this.$t("notifications.transport"),
                //   value: "transport",
                // },
            ];
        },
    },
    watch: {         
        matrimonio: function (newQuestion, oldQuestion) {
        this.validDisabled();
        },
        concubina: function (newQuestion, oldQuestion) {
        this.validDisabled();
        },
        padre: function (newQuestion, oldQuestion) {
        this.validDisabled();
        },
        hijo: function (newQuestion, oldQuestion) {
        this.validDisabled();
        },
        paternidad: function (newQuestion, oldQuestion) {
        this.validDisabled();
        },
        subsidiada_1: function (newQuestion, oldQuestion) {
        this.validDisabled();
        },
        subsidiada_2: function (newQuestion, oldQuestion) {
        this.validDisabled();
        },
        subsidiada_3: function (newQuestion, oldQuestion) {
        this.validDisabled();
        },
        subsidiada_4: function (newQuestion, oldQuestion) {
        this.validDisabled();
        },
    },
    beforeMount: function () {
        this.getData();
    },
    methods: {
        validDisabled:function(){            
            if(this.alertType=="economicas"){
                if(this.dataTemporalEconomica.concubina==this.concubina && this.dataTemporalEconomica.matrimonio==this.matrimonio && 
                this.dataTemporalEconomica.padre==this.padre && this.dataTemporalEconomica.hijo==this.hijo && 
                this.dataTemporalEconomica.paternidad==this.paternidad){
                    this.validChange= true;
                }else{
                    this.validChange=  false;
                }
            }else if(this.alertType=="subsidiadas"){
                if(this.dataTemporalSubsidial.subsidiada_1==this.subsidiada_1 && this.dataTemporalSubsidial.subsidiada_2 ==this.subsidiada_2 &&
                this.dataTemporalSubsidial.subsidiada_3==this.subsidiada_3 && this.dataTemporalSubsidial.subsidiada_4 ==this.subsidiada_4
                ){
                    this.validChange= true;
                }else{
                    this.validChange=  false;
                }
            }
        },
        getNotifications: async function (type) {
            this.alertType = type;

            this.concubina =this.dataTemporalEconomica.concubina;
            this.matrimonio =this.dataTemporalEconomica.matrimonio;
            this.padre=this.dataTemporalEconomica.padre;
            this.hijo=this.dataTemporalEconomica.hijo;
            this.paternidad=this.dataTemporalEconomica.paternidad;
            this.subsidiada_1=this.dataTemporalSubsidial.subsidiada_1 
            this.subsidiada_2=this.dataTemporalSubsidial.subsidiada_2
            this.subsidiada_3=this.dataTemporalSubsidial.subsidiada_3
            this.subsidiada_4=this.dataTemporalSubsidial.subsidiada_4

            this.validDisabled();

        },
        save:async function () {
            try{
            this.$store.commit("global/SET_LOADING", true);
            if(this.alertType=="economicas"){
                let arregloSend=[
                    {
                        token:"defuncion_conyuge",
                        name:"Definición cónyuge o concubina/o",
                        value:this.concubina
                    },
                    {
                        token:"matrimonio",
                        name:"Matrimonio",
                        value:this.matrimonio
                    },
                    {
                        token:"defuncion_padre",
                        name:"Defunción de padre o madre",
                        value:this.padre
                    },
                    {
                        token:"defuncion_hijo",
                        name:"Defunción de hijo o hija",
                        value:this.hijo
                    },
                    {
                        token:"paternidad",
                        name:"Paternidad",
                        value:this.paternidad
                    },
                ];
                for (let index = 0; index < arregloSend.length; index++) {
                    if(arregloSend[index].value != ""){
                        await api.saveCompensationsNoEconomic(arregloSend[index])
                    }
                }
                


            }else if(this.alertType=="subsidiadas"){
                let arregloSend=[
                    {
                        token:"prestacion_subsidiaria_1",
                        name:this.subsidiada_1,
                    },
                    {
                        token:"prestacion_subsidiaria_2",
                        name:this.subsidiada_2,
                    },
                    {
                        token:"prestacion_subsidiaria_3",
                        name:this.subsidiada_3,
                    },
                    {
                        token:"prestacion_subsidiaria_4",
                        name:this.subsidiada_4,
                    },
                ];
                for (let index = 0; index < arregloSend.length; index++) {
                    if(arregloSend[index].name != ""){
                        await api.saveCompensationsSubsidiary(arregloSend[index])
                    }
                }

            }
            this.$store.commit("global/SET_LOADING", false);
            this.getData();

            this.$store.commit("global/SET_ALERT", {
            msg: this.$t('global.successSaved'),
            show: true,
            type: "success"
            });

        }catch(error){

            this.$store.commit("global/SET_LOADING", false);

            this.$store.commit("global/SET_ALERT", {
            msg: "Error al guardar la información",
            show: true,
            type: "error"
            });
        }
        },

        getData:async function () {
            this.$store.commit("global/SET_LOADING", true);
            const resp = await api.getCompensationsNoEconomic(); 
            for (let index = 0; index < resp.data.items.length; index++) {
                if(resp.data.items[index].token=="defuncion_conyuge"){
                    this.concubina=resp.data.items[index].value
                    this.dataTemporalEconomica.concubina=resp.data.items[index].value;
                }else if(resp.data.items[index].token=="matrimonio"){
                    this.matrimonio=resp.data.items[index].value
                    this.dataTemporalEconomica.matrimonio=resp.data.items[index].value;
                }else if(resp.data.items[index].token=="defuncion_padre"){
                    this.padre=resp.data.items[index].value
                    this.dataTemporalEconomica.padre=resp.data.items[index].value;
                }else if(resp.data.items[index].token=="defuncion_hijo"){
                    this.hijo=resp.data.items[index].value
                    this.dataTemporalEconomica.hijo=resp.data.items[index].value;
                }else if(resp.data.items[index].token=="paternidad"){
                    this.paternidad=resp.data.items[index].value
                    this.dataTemporalEconomica.paternidad=resp.data.items[index].value;
                }
            }
            const respSubsidiary = await api.getCompensationsSubsidiary(); 
            for (let index = 0; index < respSubsidiary.data.items.length; index++) {
                if(respSubsidiary.data.items[index].token=="prestacion_subsidiaria_1"){
                    this.subsidiada_1=respSubsidiary.data.items[index].name
                    this.dataTemporalSubsidial.subsidiada_1=respSubsidiary.data.items[index].name;
                }else if(respSubsidiary.data.items[index].token=="prestacion_subsidiaria_2"){
                    this.subsidiada_2=respSubsidiary.data.items[index].name
                    this.dataTemporalSubsidial.subsidiada_2=respSubsidiary.data.items[index].name;
                }else if(respSubsidiary.data.items[index].token=="prestacion_subsidiaria_3"){
                    this.subsidiada_3=respSubsidiary.data.items[index].name
                    this.dataTemporalSubsidial.subsidiada_3=respSubsidiary.data.items[index].name;
                }else if(respSubsidiary.data.items[index].token=="prestacion_subsidiaria_4"){
                    this.subsidiada_4=respSubsidiary.data.items[index].name
                    this.dataTemporalSubsidial.subsidiada_4=respSubsidiary.data.items[index].name;
                }
            }
            /**
             * 
             * matrimonio:"",//ya
            concubina:"",//ya
            padre:"",//ya
            hijo:"",//ya
            paternidad:"",
            subsidiada_1:"",
            subsidiada_2:"",
            subsidiada_3:"",
            subsidiada_4:"",
             */
            
    
    
            this.$store.commit("global/SET_LOADING", false);
            this.validDisabled();
        },
        
    },
};
</script>

<style lang="scss" scoped>
.section-container {
    margin: 40px 0px;

    .section-title {
        margin-bottom: 10px;
    }

    .cards-container {
        display: flex;
        // flex-wrap: wrap;
        flex-wrap: wrap;
        flex-direction: row;
        // align-items: flex-start;
        justify-content: flex-start;
    }

    .btn-container {
        display: contents;
    }
}

.edit-btn {
    color: $black;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

    &:hover {
        color: $black;
    }
}

.delete-btn {
    @extend %audi;
    color: $black;
    cursor: pointer;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

    &:hover {
        color: $warn_red;
        text-decoration: underline;
    }
}

.modal-title {
    margin: 0;
}

.controls {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
}

.controls .control {
    margin-left: 15px;
    font-size: 16px;
    cursor: pointer;
}

.control.cancel-btn {
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

    &:hover {
        text-decoration: underline;
    }
}

.control.delete-btn {
    @extend %audi-b;
    color: $white;
    background-color: $black;
    border-color: $black;
    padding: 10px 20px;
    border-radius: 0px;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

    &:hover {
        background-color: $warn_red;
        border-color: $warn_red;
    }
}

.icons-black {
    color: #000;
    font-size: 16px;
    cursor: pointer;
}

.icons-black:hover {
    color: #000;
}
.input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 18px;
  margin: 20px 0px;

  label {
    @extend %audi-b;
  }
}
.input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 18px;
  margin: 20px 0px;

  label {
    @extend %audi-b;
  }
}
.recipients p {
  margin: 0;
}
.form-container {
  width: 90%;

  @media (min-width: 769px) {
    width: 65%;
  }
  @media (min-width: 1216px) {
    width: 55%;
  }
  @media (min-width: 1408px) {
    width: 45%;
  }
}
.mt{
    margin-top: 50px;
}
.controls {
  display: flex;
  margin-bottom: 30px;
  margin-top: 30px;

}

.controls .upload-btn {
  background-color: #000;
  border-radius: 0px;
  color: #fff;
  margin-left: 1rem;
}

.controls .upload-btn:hover {
  color: #fff;
}
.save-btn {
    margin: 0 0 0 10px;
    color: white;
    background-color: black;
    border-color: black;
    padding: 8px 20px;
    border-radius: 0px;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  }
  .flex_row{
    max-width: 100%;
    min-width: 100% !important;
    display: flex;
    flex-direction: row;
    margin-top: 50px;
    justify-content: space-between;
    align-items: center;
  }
</style>